import { SectionHeading, Reveal } from "./shared";

const STEPS = [
  {
    num: "01",
    name: "Recebimento & Avaliação",
    desc: "Traga à loja na Av. São Borja, 412 (Rio Branco) ou combine o envio. Fazemos um check-up completo do aparelho.",
  },
  {
    num: "02",
    name: "Orçamento Transparente",
    desc: "Você recebe o orçamento pelo WhatsApp com fotos do defeito. Sem surpresa e sem compromisso.",
  },
  {
    num: "03",
    name: "Reparo com Carinho",
    desc: "Peças de qualidade e mão de obra especializada, com fotos do antes e depois.",
  },
  {
    num: "04",
    name: "Testes & Garantia",
    desc: "Testamos tudo — câmera, som, biometria — e você sai com a garantia documentada.",
  },
];

export default function Steps() {
  return (
    <section id="protocolo" className="relative py-24 sm:py-32 px-4 sm:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-grid-millimetric opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto">
        <SectionHeading
          overline="/// Como Funciona"
          title="DO ORÇAMENTO À ENTREGA EM 4 PASSOS"
          subtitle="Você acompanha cada etapa pelo WhatsApp, com fotos e atualizações. Simples assim."
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.1}>
              <div
                data-testid={`protocol-step-${s.num}`}
                className="relative h-full rounded-2xl border border-white/10 bg-[#2E373E]/80 backdrop-blur-sm p-6 hover:border-[#99BA4B]/60 hover:-translate-y-1 transition-all duration-300"
              >
                <span className="font-display text-4xl text-[#99BA4B]/30">{s.num}</span>
                <div className="mt-4 h-px w-10 bg-[#99BA4B]/60" />
                <h3 className="mt-4 font-display text-lg text-white">{s.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-300">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
